export default __webpack_public_path__ + "static/SpaceGrotesk-Medium-d188dfade7a12bbb16c1d69e2b8747a3.ttf";